import { render, staticRenderFns } from "./ProjectAccountingTabs.vue?vue&type=template&id=1cd8ff4b&scoped=true&"
import script from "./ProjectAccountingTabs.vue?vue&type=script&lang=ts&"
export * from "./ProjectAccountingTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectAccountingTabs.vue?vue&type=style&index=0&id=1cd8ff4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd8ff4b",
  null
  
)

export default component.exports